import React, { useEffect, useState } from 'react'
import { tabs } from '../../indicators/components/screening.component';
import { useNavigate, useParams } from 'react-router-dom';
import { useKato } from '../../../contexts/kato.context';
import classes from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import HumanResourcesTab from './screening-tabs/human-resources-tab.component';
import LandFundTab from './screening-tabs/land-fund-tab.component';
import AgricultureTab from './screening-tabs/agriculture-tab.component';
import SmbDevelopmentTab from './screening-tabs/smb-development-tab.component';
import SwotAnalysisTab from './screening-tabs/swot-analysis-tab.component';

const baseClass = 'screening-tab';

const ScreeningTab = () => {
    const { t } = useTranslation();
    const { screeningInfo } = useKato();
    const { kato, tab } = useParams<{ tab: string, kato: string }>();
    const [selectedTab, setSelectedTab] = useState(tabs[0]);
    const navigate = useNavigate();

    const handleTabChange = (tab: string) => {
        if (tab !== selectedTab) {
            navigate(`/admin/${kato}/screening/${tab}`);
            setSelectedTab(tab);
        }
    }

    useEffect(() => {
        if (!tab) {
            navigate(`${tabs[0]}`)
        }

        setSelectedTab(tab || tabs[0]);
    }, [tab]);

    if (!screeningInfo) return null;

    return (
        <div className={classes[baseClass]}>
            <div className={classes[`${baseClass}__tabs`]}>
                {tabs.map((tab: string) => (
                    <div
                        key={tab}
                        className={selectedTab === tab ? `${classes[`${baseClass}__tab`]} ${classes[`${baseClass}__tab--active`]}` : classes[`${baseClass}__tab`]}
                        onClick={() => handleTabChange(tab)}
                    >
                        {t('screening.tabs.' + tab)}
                    </div>
                ))}
            </div>

            <div className={classes[`${baseClass}__content`]}>
                {
                    selectedTab === 'human-resources' && <HumanResourcesTab />
                }
                {
                    selectedTab === 'land-fund' && <LandFundTab />
                }
                {
                    selectedTab === 'agriculture' && <AgricultureTab />
                }
                {
                    selectedTab === 'smb-development' && <SmbDevelopmentTab />
                }
                {
                    selectedTab === 'swot-analysis' && <SwotAnalysisTab />
                }
            </div>
        </div>
    )
}

export default ScreeningTab